export const STORAGE_KEYS = {
  USER: 'user',
  WALLET: 'wallet'
} as const

export { USER_ROLES } from '@chessx/shared/constants'

export const HEROES_PAGE_LIMIT = 12
export const USER_PAGE_LIMIT = 20

const PIECE_TYPE = {
  p: true,
  n: true,
  b: true,
  r: true,
  q: true,
  k: true
}
const HERO_COLOR = { white: true, black: true }
const HERO_SALE_STATUS = { forsale: true, notforsale: true }
export const DEFAULT_FILTER = {
  status: HERO_SALE_STATUS,
  color: HERO_COLOR,
  pieceType: PIECE_TYPE
}

export const MONTHS = [
  { name: 'January', value: '1' },
  { name: 'February', value: '2' },
  { name: 'March', value: '3' },
  { name: 'April', value: '4' },
  { name: 'May', value: '5' },
  { name: 'June', value: '6' },
  { name: 'July', value: '7' },
  { name: 'August', value: '8' },
  { name: 'September', value: '9' },
  { name: 'October', value: '10' },
  { name: 'November', value: '11' },
  { name: 'December', value: '12' }
]
